'use strict';

/* global $ */

import { getAjax } from '../utils/ajax';
import { _init, myMap } from './map';

function GetProject(options) {

    let settings = {
        formSelector: '.js-project-filter',
        formTabSelector: '.js-project-filter-tab',
        formNameSelector: '.js-project-filter-name',
        formBlockSelector: '.js-project-filter-block',
        selectSelector: '.js-project-select',
        checkboxSelector: '.js-project-checkbox',
        checkedSelector: '.same-as-selected',
        blockSelector: '.js-project-map',
        listSelector: '.js-project-list',
    };

    let opt = $.extend({}, settings, options);
    let forma = opt.formSelector,
        forma_tab = opt.formTabSelector,
        forma_filter_name = opt.formNameSelector,
        forma_filter_block = opt.formBlockSelector,
        type = opt.selectSelector,
        check = opt.checkedSelector,
        list = opt.listSelector,
        block = opt.blockSelector,
        checkbox = opt.CheckboxSelector;

    $(forma_filter_name).on('click', function(e) {
        e.preventDefault();
        $(this).toggleClass('is-open').next(forma_filter_block).toggleClass('is-open');
    });

    $(forma).on('click', '.js-project-select.js-project-select', function(e) {
        e.preventDefault();
        let form = $(forma);
        let branch = 'js-branch',
            status = 'js-status',
            region = 'js-region',
            filter = 'js-filter';

        let data = {};
        data = form.data();
        $(check).each(function() {
            if (this.classList.contains(region)) {
                data.region = $(this).data().object_id;
            } else if (this.classList.contains(branch)) {
                data.branch = $(this).data().object_id;
            } else if (this.classList.contains(status)) {
                data.status = $(this).data().object_id;
            }

        });
        console.log(data);
        getAjax('get_project', data).then(function(data) {
            if (data.ok) {
                $(block).html(data.projects);
                $(list).html(data.projects_list);
                myMap.geoObjects.removeAll();
                _init(myMap);
            } else {
                console.error('Can\'t get form');
            }
        }).catch(function(error) {
            throw new Error(error);
        });

    });

    console.error($(forma_tab));

    $(forma_tab).find('.js-checkbox').on('change', function(e) {
        //e.preventDefault();
        let form = $(this).parents('form').get(0);
        let list = $(this).parents('.js-tabs__item.is-active').find(opt.listSelector);
        console.error(form);
        //let data = {
        //    filter: form.find('.js-checkbox:checked').serialize()
        //};
        let params = new FormData(form);
        //data = form(filter).data();
        //form.find('.js-filter:checked').serialize();
        console.error(params);
        getAjax('get_project', params).then(function(data) {
            if (data.ok) {
                $(block).html(data.projects);
                $(list).html(data.projects_list_new);
                myMap.geoObjects.removeAll();
                _init(myMap);
            } else {
                console.error('Can\'t get form');
            }
        }).catch(function(error) {
            throw new Error(error);
        });

    });
}

export {
    GetProject
};
